import cross from './images/cross.png';
import edit from './images/st5.png';
import axios from "axios";
import { useEffect, useState } from "react";
import SideBar from './sidebar';
function Tests()
{
    let [tests,setTests]=useState([]);
    let [vendors,setVendors]=useState([]);
    let [svid,setSvid]=useState("");
    let file={filedata:"",filetype:"",filename:""};
    function checkfile(event)
    {
        //application/pdf
        //application/msword
        //application/vnd.openxmlformats-officedocument.wordprocessingml.document
        if(event.target.files && event.target.files.length>0)
        {
            let size=event.target.files[0].size;
            let name=event.target.files[0].name;
            let type=event.target.files[0].type;
            if(size>=500*1024)
            {
                alert("File Size should be less than<500KB !!");
                event.target.value="";
                return;
            }
            else if(!(type=="application/pdf" || type=="application/msword" || type=="application/vnd.openxmlformats-officedocument.wordprocessingml.document"))
            {
                alert("Only Word/PDF is valid!!!");
                event.target.value="";
                return;
            }
            else
            {
                let fr=new FileReader();
                fr.onloadend=(e)=>
                {
                    let data=fr.result;
                    let idx=data.indexOf("base64,")+7;
                    file={filedata:data.substring(idx),filetype:type,filename:name};
                };
                fr.readAsDataURL(event.target.files[0]);
            }
        }
    }
    function doEdit(id)
    {
        let rec=tests.filter((e)=>e.tid==id);
        if(rec.length==1)
        {
            document.getElementById("t1").value=rec[0].testname;
            document.getElementById("t0").value=rec[0].tid;
            setSvid(rec[0].vid);            
        }
        else
        {
            alert("No Record Found!!!");
        }
    }
    function doDelete(id)
    {
        if(window.confirm("Are you sure?"))
        {
            let json=JSON.stringify({tid:id});
            let config={headers:{"Content-Type":"application/json",}};
            axios.post(process.env.REACT_APP_APIURL+"tests.php?opr=D",json).then(reply=>
            {
                if(reply.status==200 && reply.data.status=="OK")    
                {
                    alert(reply.data.message);
                    document.getElementById("t0").value="";
                    document.getElementById("t1").value="";
                    document.getElementById("t3").value="";
                    getAllTests();
                }
            });
        }
    }
    function getAllTests()
    {
        let config={headers:{"Content-Type":"application/json",}};
        axios.get(process.env.REACT_APP_APIURL+"tests.php").then(reply=>
        {
            if(reply.status==200 && reply.data.status=="OK")    
            {
                setTests(reply.data.data);
            }
        });
    }
    function getAllVendors()
    {
        let config={headers:{"Content-Type":"application/json",}};
        axios.get(process.env.REACT_APP_APIURL+"vendors.php").then(reply=>
        {
            if(reply.status==200 && reply.data.status=="OK")    
            {
                setVendors(reply.data.data);
            }
        });
    }
    function saveData(event)
    {
        event.preventDefault();
        let s0=document.getElementById("t0").value;
        let s1=document.getElementById("t1").value;
        let s2=document.getElementById("t2").value;
        if(s1.length<3)
        {
            alert("Invalid Test Name/Missing!!!");
            document.getElementById("t1").focus();
            return;
        }
        if(s2=="0")
        {
            alert("Select Vendor!!!");
            document.getElementById("t2").focus();
            return;
        }
        let obj={tid:s0,testname:s1,vid:s2,protocol:"",protocolfiletype:"",protocolfilename:""};
        if(file.filename!="")
        {
            obj.protocol=file.filedata;
            obj.protocolfiletype=file.filetype;
            obj.protocolfilename=file.filename;
        }
        let json=JSON.stringify(obj);
        let config={headers:{"Content-Type":"application/json",}};
        if(s0=="" || s0=="0")
        {
            axios.post(process.env.REACT_APP_APIURL+"tests.php?opr=S",json).then(reply=>
            {
                if(reply.status==200 && reply.data.status=="OK")
                {
                    alert(reply.data.message);
                    document.getElementById("t0").value="";
                    document.getElementById("t1").value="";
                    document.getElementById("t3").value="";
                    getAllTests();
                }
                else
                {
                    alert(reply.data.message);
                }
            });
        }
        else
        {
            axios.post(process.env.REACT_APP_APIURL+"tests.php?opr=U",json).then(reply=>
            {
                if(reply.status==200 && reply.data.status=="OK")
                {
                    alert(reply.data.message);
                    document.getElementById("t0").value="";
                    document.getElementById("t1").value="";
                    document.getElementById("t3").value="";
                    getAllTests();
                }
                else
                {
                    alert(reply.data.message);
                }
            });
        }
    }
    function getDownloadURL(id)
    {
        return(
            <a href={process.env.REACT_APP_APIURL+"download.php?tbl=tst&id="+id}>Download</a>
        );
    }
    useEffect(()=>{
        getAllVendors();
        getAllTests();
    },[]);
    return(
                
        <div className="container">
            <div className="mt-3">
                <form onSubmit={saveData}>
                    <div className="card shadow">
                        <div className="card-header text-center bg-danger text-white h5">Test Details</div>
                        <div className="card-body">
                            <div className="row">
                                <input type="hidden" id="t0"/>
                                <div className="form-group col-xxl-4 col-xl-4 col-lg-4 col-12">
                                    <label>Test Name</label>
                                    <input type="text" id="t1" className="form-control form-control-sm" required/>
                                </div>                                
                                <div className="form-group col-xxl-4 col-xl-4 col-lg-4 col-12">
                                    <label>Vendor Name</label>
                                    <select id="t2" className="form-control form-control-sm" required>
                                        <option value="0">Select Vendor</option>
                                        {vendors.map((e,i)=><option value={e.vid} selected={e.vid==svid}>{e.vname}</option>)}
                                    </select>
                                </div>
                                <div className="form-group col-xxl-4 col-xl-4 col-lg-4 col-12">
                                    <label>Protocol File</label>
                                    <input id="t3" accept=".pdf,.doc,.docx" type="file" onChange={checkfile} className="form-control form-control-sm" />
                                </div>                                
                            </div>
                            <input type="submit" value="Add/Update Test" className={window.urole.toUpperCase()=="ADMINISTRATOR"?"btn btn-danger mt-3":"btn btn-danger mt-3 disabled"} />
                            <hr/>
                            <div style={{overflow:"auto"}}>
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>S.No.</th>
                                            <th>Test Name</th>
                                            <th>Vendor</th>
                                            <th>Vendor Address</th>
                                            <th>Protocol File</th>
                                            <th className='text-success'>Completed</th>
                                            <th className='text-info'>Running</th>
                                            <th className='text-danger'>Delayed</th>
                                            <th></th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tests.map((e,i)=>
                                            <tr>
                                                <td>{i+1}</td>
                                                <td>{e.testname}</td>
                                                <td>{e.vname}</td>
                                                <td>{e.address}</td>
                                                <td>{e.protocolfilename==""?"No File":getDownloadURL(e.tid)}</td>
                                                <td className='text-success'>{e.completed}</td>                                            
                                                <td className='text-info'>{e.running}</td>                                            
                                                <td className='text-danger'>{e.delayed}</td>                                            
                                                <td><img src={edit} width="25px" style={{cursor:'pointer'}} onClick={()=>{doEdit(e.tid);}} /></td>
                                                <td><img src={cross} width="25px" style={{cursor:'pointer'}} onClick={()=>{doDelete(e.tid);}} /></td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="card-footer bg-danger"></div>
                    </div>
                </form>
            </div>
        </div>
        
    );
}
export default Tests;